<form name="FrmContactRow" #contactRowForm="ngForm" autocomplete="nope">
    <div class="d-flex flex-wrap mb-1" *ngIf="contact">
        <div class="mx-1" style="width:150px;">
            <paf-combobox *ngIf="contact.Civility.Id"
                name="civility" 
                headerPafLabel="Civilite"
                [bindToId]="true"
                [disabled]="disabled || onlyIntUsers|| !editActivated" 
                [(ngModel)]="contact.Civility.Id"
                [required]="true"
                [data]="sharedDataSvc.civilities" style="width:100%;"></paf-combobox>
            <validation-errors [form]="contactRowForm" controlName="civility"></validation-errors>
            
        </div>
        <div class="mx-1" style="width:180px;">
            <label class="control-label" paflabel="Prenom"></label>
            <input type="text" class="form-control" id="Firstname" name="Firstname" [(ngModel)]="contact.Firstname" style="width:100%;"
                upperCase [disabled]="disabled || onlyIntUsers || !editActivated" required autocomplete="nope" />
            <validation-errors [form]="contactRowForm" controlName="Firstname"></validation-errors>
        </div>
        <div class="mx-1" style="width:180px">
            <label class="control-label" paflabel="Nom"></label>
            <input type="text" class="form-control" id="Lastname" name="Lastname" [(ngModel)]="contact.Lastname" style="width:100%;"
                upperCase [disabled]="disabled || onlyIntUsers || !editActivated" required autocomplete="nope" />
            <validation-errors [form]="contactRowForm" controlName="Lastname"></validation-errors>
        </div>
        <div class="mx-1" style="width:180px">
            <label class="control-label" paflabel="Fonction"></label>
            <input type="text" class="form-control" id="Fonction" name="Fonction" [(ngModel)]="contact.Fonction" style="width:100%;"
                [disabled]="disabled || onlyIntUsers || !editActivated" autocomplete="nope" style="width:100%;" />
        </div>
        <div class="mx-1" style="width:100px">
            <label class="control-label" paflabel="Telephone"></label>
            <input type="text" class="form-control" id="Phone" name="Phone" [(ngModel)]="contact.Phone" style="width:100%;"
                [disabled]="disabled || onlyIntUsers || !editActivated" required autocomplete="nope" />
            <validation-errors [form]="contactRowForm" controlName="Phone"></validation-errors>
        </div>
        <div class="mx-1" style="width:100px" >
            <label class="control-label" paflabel="Mobile"></label>
            <input type="text" class="form-control" id="CellPhone" name="CellPhone" [(ngModel)]="contact.CellPhone" style="width:100%;"
                [disabled]="disabled || onlyIntUsers || !editActivated" autocomplete="nope" />
        </div>
        <div class="mx-1" style="width:180px;">
            <label class="control-label" paflabel="Email"></label>
            <input *ngIf="!(onlyIntUsers || onlyExtUsers)" type="email" email="true" required class="form-control" style="width:100%;"
                id="Email" name="Email" [(ngModel)]="contact.Email" [emailUnique]="contact.Id"
                [disabled]="disabled || !editActivated" autocomplete="nope" />
            <div *ngIf="onlyIntUsers" style="width:100%;">
                <kendo-combobox 
                    [data]="intUsersFiltered" 
                    [filterable]="true" 
                    [(ngModel)]="intUserSel" 
                    [textField]="'displayMail'"
                    [valueField]="'Id'" 
                    [valuePrimitive]="false" 
                    name="Email" 
                    autocomplete="nope" 
                    [disabled]="disabled || !editActivated"
                    required 
                    (filterChange)="intUsersFilterChange($event)" style="width:100%;">
                    <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                        <div class="d-flex flex-column">
                            <div>{{dataItem.displayName}}</div>
                            <div class="small">{{dataItem.displayMail}}</div>
                        </div>
                    </ng-template>
                </kendo-combobox>
            </div>
            <validation-errors [form]="contactRowForm" controlName="Email"></validation-errors>
        </div>
        <div class="flex-grow-1 text-right">
            <div *ngIf="!disabled" class="btn-group-xs pt-4">
                <button *ngIf="!disabled && !editActivated" class="btn btn-xs btn-warning" (click)="edit()"><i
                        class="fas fa-user-edit"></i></button>
                <button *ngIf="editActivated" class="btn btn-xs btn-default" (click)="undo()">
                    <i class="fas fa-undo"></i></button>
                <button *ngIf="editActivated" class="btn btn-xs btn-primary" [disabled]="contactRowForm.invalid"
                    (click)="update()"><i class="fas fa-user-check"></i></button>
            </div>
        </div>
    </div>
</form>